import { render, staticRenderFns } from "./TheMobileSidebar.vue?vue&type=template&id=b4271e28&scoped=true&"
import script from "./TheMobileSidebar.vue?vue&type=script&lang=js&"
export * from "./TheMobileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheMobileSidebar.vue?vue&type=style&index=0&id=b4271e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4271e28",
  null
  
)

export default component.exports